export function getWidthAndHeightProps(props) {
    var _a;
    if (props.fullWidth === true) {
        props.width = '100%';
    }
    if (props.block === true)
        props.width = '100%';
    if (props.fullHeight === true)
        props.height = '100%';
    if (props.fluid === true && !props.width)
        props.width = '100%';
    if (props.fluid === true && !props.height)
        props.height = '100%';
    if (props.viewPortHeight === true)
        props.height = '100vh';
    else if (props.viewPortHeight)
        props.height = "".concat(props.viewPortHeight, "vh");
    if (props.viewPortWidth === true)
        props.width = '100vw';
    else if (props.viewPortWidth)
        props.width = "".concat(props.viewPortWidth, "vw");
    if (props.clip === true && !props.minWidth)
        props.minWidth = 0;
    var toUseStyles = {};
    if (props.minWidth || props.minWidth == 0)
        toUseStyles.minWidth = props.minWidth;
    if (props.maxWidth || props.maxWidth == 0)
        toUseStyles.maxWidth = props.maxWidth;
    if (props.minHeight || props.minHeight == 0)
        toUseStyles.minHeight = props.minHeight;
    if (props.maxHeight || props.maxHeight == 0)
        toUseStyles.maxHeight = props.maxHeight;
    if (props.height || props.height == 0)
        toUseStyles.height = props.height;
    if (props.width || props.width === 0)
        toUseStyles.width = props.width;
    if (props.size || props.size === 0)
        toUseStyles.width = props.size;
    if (props.size || props.size === 0)
        toUseStyles.height = props.size;
    if (props.zIndex)
        toUseStyles.zIndex = props.zIndex;
    if (typeof props.top !== 'undefined')
        toUseStyles.top = props.top;
    if (typeof props.right !== 'undefined')
        toUseStyles.right = props.right;
    if (typeof props.left !== 'undefined')
        toUseStyles.left = props.left;
    if (typeof props.bottom !== 'undefined')
        toUseStyles.bottom = props.bottom;
    var classesToUse = (_a = {},
        _a["display-".concat(props.display)] = typeof props.display === 'string',
        _a["content-display-".concat(props.display)] = typeof props.contentDisplay === 'string',
        _a["position-".concat(props.position)] = typeof props.position === 'string',
        _a["float-".concat(props.float)] = typeof props.float === 'string',
        _a);
    return {
        classes: classesToUse,
        props: {},
        styles: toUseStyles,
        variables: {}
    };
}
